// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"5bf3ba84","722":"78fad031","732":"a27f8c23","977":"620cb9a5"}[chunkId] + ".chunk.js");